import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from './Basic/Tooltip';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    cursor: 'pointer',
  },
}));

const TooltipEnclosure = ({
  className = '',
  children = '',
  title = '',
  tooltipProps = {},
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <Tooltip title={title} {...tooltipProps}>
      <div className={`${classes.root} ${className}`} {...restProps}>
        {children}
      </div>
    </Tooltip>
  );
};

export default TooltipEnclosure;
